const Savings401KIntro ={

    summaryText: "A 401(k) is a special kind of retirement account that helps you save " +
        "money for the future — and rewards you for doing it. ",

    moreInformation: "Money you put into your 401(k) grows over time through investments, " +
        "and often your employer will match part of your contribution (free money!). But " +
        "there’s a catch: this money is meant for retirement, so taking it out early comes " +
        "with significant penalties (costs). In this game, contributing to your 401(k) can " +
        "help boost your long-term score; but only if you keep enough cash on hand for " +
        "day-to-day expenses. A smart starting point is to contribute enough to get the full " +
        "employer match, if available. After that, increase your savings when your budget  " +
        "allows. Balance is key: save for tomorrow, but don’t trip over today."

}

export default Savings401KIntro;